import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertNotificationService, ApiService, CommonFunctionsService, DatastoreService } from '../../services';
import { NgxSpinnerService } from "ngx-spinner";
import moment from 'moment-timezone';

@Component({
  selector: 'app-ceremony-choices',
  templateUrl: './ceremony-choices.component.html',
  styleUrls: ['./ceremony-choices.component.scss']
})
export class CeremonyChoicesComponent implements OnInit {

  config: any;
  site: string = "";
  ceremony_choices: string = "ceremony_choices";
  companyDetails: any;
  formData: any = false;
  canSubmit: boolean = false;
  booking: any;
  attachedFiles: any = [];
  deletedFiles: any = [];
  uploadSuccess: EventEmitter<boolean> = new EventEmitter();
  saved: boolean = false;
  locked: boolean = false;
  lockedMessage = '';


  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private alerts: AlertNotificationService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
    });
    this.booking = this.dataStore.booking;
    if (!this.booking) {
      const bookingStr = localStorage.getItem('ceremony') as string;
      this.booking = JSON.parse(bookingStr);
    }
    this.setup();
  }

  async setup() {
    const configStr = this.dataStore.config;
    const config = JSON.parse(configStr);
    console.log(config);
    this.config = config;
    if (this.config.hasOwnProperty('myCeremony')) {
      if (this.config.myCeremony.hasOwnProperty('ceremony-choices')) {
        if (this.config.myCeremony['ceremony-choices'].hasOwnProperty('lock')) {
          const lockSplit = this.config.myCeremony['ceremony-choices'].lock.split(' ');
          const duration = lockSplit[0];
          const frequency = lockSplit[1];

          const bookingTime = moment(this.booking.datetime).utc().tz('Europe/London');
          const dateToLock = moment(this.booking.datetime).utc().tz('Europe/London').subtract(duration, frequency);
          console.log('bookingTime', bookingTime.format('YYYY-MM-DD'), 'dateToLock', dateToLock.format('YYYY-MM-DD'));
          if (moment().utc().tz('Europe/London').isSameOrBefore(dateToLock)) {
            this.locked = false;
          }
          else {
            this.locked = true;
          }

        }
        if (this.config.myCeremony['ceremony-choices'].hasOwnProperty('lockedMessage')) {
          this.lockedMessage = this.config.myCeremony['ceremony-choices'].lockedMessage.trim();
        }
      }
    }
    console.log('CHOICES LOCK', this.locked);
    console.log("bb", this.booking)
    const service: any = await this.apiService.getService(this.booking.company_id, this.booking.service_id)
    console.log("service", service)
    this.ceremony_choices = 'ceremony_choices_' + service.global_id
    const meta: any = await this.apiService.getMetadataForBooking(this.booking.company_id, this.booking.id, 'ceremony_choices');
    console.log("meta", meta);
    if (meta.Item) {
      this.formData = meta.Item.data;
      this.dataStore.loadedApplication = [meta.Item.data]
    } else {
      this.formData = []
    }
    console.log("this.formData", this.formData)
  }

  formStatus(data: any) {
    console.log(data);
    this.canSubmit = data.status;
  }

  fileStatus(data: any) {
    console.log(data);
    this.attachedFiles = data.attachedFiles
    this.deletedFiles = data.deletedFiles
    console.log(this.attachedFiles);
    console.log(this.deletedFiles);
  }

  async saveForm() {
    const formData = JSON.parse(JSON.stringify(this.dataStore.childrenToRegister));

    this.saved = false

    console.log("this.attachedFiles)", this.attachedFiles)
    for (const file of this.attachedFiles) {
      console.log("file", file, file.uuid, file.uuid === undefined)
      if (file.uuid === undefined) {

        await this.apiService.directJrniUpload(JSON.parse(this.dataStore.config), file, this.booking.purchase_ref, this.booking.id)
      }
    }
    console.log("this.deletedFiles", this.deletedFiles)
    for (const file of this.deletedFiles) {
      if (file.uuid !== undefined) {
        await this.apiService.jrniDeleteFile(JSON.parse(this.dataStore.config), this.booking.company_id, this.booking.purchase_ref, this.booking.id, file.uuid)
      }
    }

    console.log(formData)
    console.log(formData[0])
    if (formData[0].length === 0) {
      alert("formData[0].length === 0")
      return "error"
    }
    const schema = this.dataStore.schema.schema.fields
    console.log("schema", schema)
    const uploadFields = formData[0].filter((x: any) => schema.find((y) => y.field === x.field && y.type === "upload"))
    const radioFields = formData[0].filter((x: any) => {

      const schemaField = schema.find((y) => y.field === x.field && y.type === "radio")
      if (schemaField) {
        x.schemaField = schemaField
        return true
      } else {
        return false
      }
    })
    console.log(radioFields)
    for (let radioField of radioFields) {
      const value = radioField.schemaField.radio_options.find((x) => x.value === radioField.value)
      if (value) {
        radioField.value = value.title
      }
    }
    console.log(this.attachedFiles)
    console.log(uploadFields)
    for (let uploadField of uploadFields) {
      const answers = this.dataStore.filesStrings[uploadField.field]
      console.log(answers)
      const finalAnswers = []
      if (answers) {
        for (let answer of answers) {
          console.log(answer)
          if (this.attachedFiles.find((x) => x.name === answer.name)) {
            finalAnswers.push(answer)
          }
          console.log(finalAnswers)
        }
      }
      uploadField.value = finalAnswers
    }


    console.log(formData[0])
    const save = await this.apiService.addMetadataToBooking(this.booking.company_id, this.booking.id, 'ceremony_choices', JSON.stringify(formData[0]));
    this.uploadSuccess.emit(true);
    this.saved = true

    // PD-815: tell the register office the choices are in. Only once the save
    // above has succeeded, and never at the customer's expense — AlertNotificationService
    // swallows its own failures, the catch here is belt and braces.
    //
    // Scoped to the booking, not to the submitted answers: the choices lock in
    // once, so the office is told once. A double-clicked Save and a later edit
    // are both suppressed.
    try {
      await this.alerts.send('choices', this.booking, this.booking.id);
    } catch (err) {
      console.error('Failed to send ceremony choices notification email', err);
    }
  }

}
